import React from 'react';
import { Link } from 'react-router-dom';
import GameCard from './GameCard';

interface Game {
  id: number;
  name: string;
  description: string;
  thumbnail: string;
  category: string;
  url: string;
  featured: boolean;
}

interface GameCategoryProps {
  title: string;
  games: Game[];
  limit?: number;
}

const GameCategory: React.FC<GameCategoryProps> = ({ title, games, limit = 4 }) => {
  // Show only up to the limit
  const displayedGames = games.slice(0, limit);
  
  return (
    <section className="py-8">
      <div className="container-custom">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-white">{title}</h2>
          <Link 
            to={`/?category=${title}`} 
            className="text-primary hover:text-primary-light text-sm font-medium"
          >
            view more
          </Link>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {displayedGames.map((game) => (
            <GameCard
              key={game.id}
              id={game.id}
              name={game.name}
              description={game.description}
              thumbnail={game.thumbnail}
              category={game.category}
            />
          ))}
        </div>
        
        {displayedGames.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500">No games found in this category.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default GameCategory; 